// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
export default {
  list(id) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/positions/${id}/history`)
    //     .then((response) => response.data)
    // );
  }
};



// WEBPACK FOOTER //
// ./src/entities/position/position-history/position-history-single/position-history-single-service.js